import { render, staticRenderFns } from "./UsersubProfileList.vue?vue&type=template&id=9dcdec20&"
import script from "./UsersubProfileList.vue?vue&type=script&lang=js&"
export * from "./UsersubProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports